import { useState } from "react";

export const useCommunityDelete = () => {
    const [deletePopUp, setDeletePopUp] = useState(false);
    const [threadToDelete, setThreadToDelete] = useState(null);
    const [answerToDelete, setAnswerToDelete] = useState(null);

    const handleCommunityDeletePopUp = (answerId, threadId) => {
        setThreadToDelete(threadId)
        setAnswerToDelete(answerId)
        setDeletePopUp(true);
      };

    const handleCommunityDeletePopUpClose = () => {
        setDeletePopUp(false);
        setThreadToDelete(null);
    };

    return { deletePopUp, threadToDelete, answerToDelete, handleCommunityDeletePopUp, handleCommunityDeletePopUpClose};
};
